<script setup lang="ts">
import type { Schemas } from "#shopware"

const props = defineProps<{
    navigationId: string
}>()

const { search } = useLandingSearch()

const { data: landingResponse, error } = await useAsyncData(
    `cmsLanding${props.navigationId}`,
    async () => {
        const landingPage = await search(props.navigationId, {
            withCmsAssociations: true,
        })
        return landingPage
    },
)

if (!landingResponse?.value) {
    console.error("[FrontendLandingPage.vue] landing page not found", error.value?.message)
    throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found',
        fatal: true
    })
}

const landingPage = landingResponse as Ref<Schemas["LandingPage"]>

useHead({
    title: landingPage.value?.metaTitle ? landingPage.value?.metaTitle : landingPage.value?.name,
    meta: [
        { name: 'description', content: landingPage.value?.metaDescription },
        {
            name: 'robots',
            content: (landingPage.value?.translated?.customFields?.prevent_indexing ?? landingPage.value?.customFields?.prevent_indexing) === true ? 'noindex, nofollow' : 'index, follow'
        }
    ],
})
</script>

<template>
    <StructurePage v-if="landingResponse?.cmsPage" :content="landingResponse.cmsPage" />
</template>
